module.exports = __webpack_public_path__ + "img/logo-main.346360f8.svg";